import React from 'react'

import theme from 'theme'

const Phone = ({
  color = theme.colors.primary,
  width = 24,
  height = 24,
  ...rest
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    {...rest}
  >
    <g clipPath="url(#clip0_37511_11755)">
      <g clipPath="url(#clip1_37511_11755)">
        <path
          d="M6.32879 2.8419L6.90237 3.66105L6.32879 2.8419ZM18.9475 20.8632L19.521 21.6824L18.9475 20.8632ZM19.1319 20.7341L18.5583 19.915L19.1319 20.7341ZM19.1762 17.4894L18.5805 18.2926L19.1762 17.4894ZM17.483 16.2335L18.0787 15.4303L17.483 16.2335ZM15.1443 16.2016L15.7179 17.0207L15.1443 16.2016ZM13.7862 17.1525L13.2655 18.0063C13.6048 18.2132 14.0343 18.1996 14.3598 17.9717L13.7862 17.1525ZM8.0507 8.96086L7.47712 8.1417C7.15165 8.3696 6.99197 8.76856 7.07034 9.15809L8.0507 8.96086ZM9.40858 8.01006L9.98216 8.82921L9.40858 8.01006ZM10.1784 5.80154L11.1369 5.51644L11.1369 5.51644L10.1784 5.80154ZM9.57737 3.78086L8.61887 4.06596L8.61887 4.06596L9.57737 3.78086ZM6.51322 2.71276L5.93965 1.89361L6.51322 2.71276ZM7.72322 15.294C6.07318 12.9375 5.21569 10.4158 5.12118 8.276C5.02606 6.12212 5.69616 4.50565 6.90237 3.66105L5.75521 2.02275C3.79459 3.39559 3.01005 5.80375 3.12313 8.36424C3.23684 10.9388 4.2504 13.8212 6.08492 16.4412L7.72322 15.294ZM18.3739 20.0441C17.1677 20.8887 15.4195 20.9655 13.4281 20.1395C11.4496 19.3188 9.37326 17.6505 7.72322 15.294L6.08492 16.4412C7.91943 19.0611 10.2814 20.9994 12.6618 21.9868C15.0292 22.9688 17.5604 23.0552 19.521 21.6824L18.3739 20.0441ZM19.521 21.6824L19.7055 21.5533L18.5583 19.915L18.3739 20.0441L19.521 21.6824ZM19.7055 21.5533C21.3828 20.3788 21.4166 17.9061 19.772 16.6863L18.5805 18.2926C19.1287 18.6992 19.1174 19.5235 18.5583 19.915L19.7055 21.5533ZM19.772 16.6863L18.0787 15.4303L16.8872 17.0367L18.5805 18.2926L19.772 16.6863ZM18.0787 15.4303C17.0416 14.6611 15.6285 14.6418 14.5708 15.3824L15.7179 17.0207C16.0705 16.7738 16.5415 16.7803 16.8872 17.0367L18.0787 15.4303ZM14.5708 15.3824L13.2127 16.3334L14.3598 17.9717L15.7179 17.0207L14.5708 15.3824ZM9.3619 14.147C10.5443 15.8357 11.9374 17.1962 13.2655 18.0063L14.307 16.2988C13.2674 15.6648 12.0645 14.5198 11.0002 12.9998L9.3619 14.147ZM7.07034 9.15809C7.3772 10.6834 8.1793 12.4581 9.3619 14.147L11.0002 12.9998C9.9357 11.4796 9.27122 9.9574 9.03105 8.76363L7.07034 9.15809ZM8.835 7.1909L7.47712 8.1417L8.62427 9.78001L9.98216 8.82921L8.835 7.1909ZM9.21992 6.08665C9.34264 6.49921 9.18759 6.94402 8.835 7.1909L9.98216 8.82921C11.0399 8.08855 11.5051 6.75414 11.1369 5.51644L9.21992 6.08665ZM8.61887 4.06596L9.21992 6.08665L11.1369 5.51644L10.5359 3.49575L8.61887 4.06596ZM7.0868 3.53191C7.64592 3.14041 8.42427 3.41173 8.61887 4.06596L10.5359 3.49575C9.95207 1.53306 7.617 0.71911 5.93965 1.89361L7.0868 3.53191ZM6.90237 3.66105L7.0868 3.53191L5.93965 1.89361L5.75521 2.02275L6.90237 3.66105Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_37511_11755">
        <rect width="24" height="24" fill="white" {...rest} />
      </clipPath>
      <clipPath id="clip1_37511_11755">
        <rect
          width="14"
          height="24"
          fill="white"
          transform="translate(-1.61719 7.18506) rotate(-35)"
          {...rest}
        />
      </clipPath>
    </defs>
  </svg>
)

export default Phone
